export const getBasePath = (path: string) => {
  return path.split("/")[1];
}